module.exports = "/static/media/icon1.3f40005c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/icon1.svg
// module id = 1485
// module chunks = 0